<template>
  <div class="content-inner">
    <div id="longTermDisability" class="content-header">
      <div class="content-header__inner">
        <h3>{{ reportTitle }}</h3>
      </div>
      <div
        class="header-actions"
        v-if="displayPrint && sectionState == 'LOADED'"
      >
        <!--- PDF button --->
        <PrintTableBtn
          :filename="reportFilename"
          :advancedPrint="isAdvancedReporting"
        />
        <!--- Excel button (In-House users only) --->
        <PrintTableBtn
          v-if="isAdvancedReporting"
          :filename="reportFilename"
          :fileFormat="'CSV'"
        />
      </div>
    </div>

    <Error v-if="hasErrors" :errors="this.errors" />

    <template v-if="sectionState == 'LOADED'">
      <div class="table-wrapper">
        <table class="months" :data-title="reportTitle" :key="reportReadyState">
          <tr
            v-for="(item, index) in getTableData()"
            :key="index"
            class="months__item"
          >
            <template v-if="index < 1">
              <th v-for="(r, i) in item" :key="i">{{ r }}</th>
            </template>
            <template v-else>
              <td v-for="(r, i) in item" :key="i">{{ r }}</td>
            </template>
          </tr>
        </table>
      </div>
    </template>
    <div v-else-if="true == loadFail" class="load-error">
      <p>
        Unable to load report information.
        <span v-if="!hasErrors">Please contact support.</span>
      </p>
    </div>
    <LoadingSpinner v-else text="Loading Data" />
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import LoadingSpinner from "@comp/LoadingSpinner";
import { HashMixin } from "@/mixins/HashMixin";
import Error from "@comp/ErrorDisplay";
import PrintTableBtn from "@comp/PrintTableBtn";

const base = "repLongTermDisability";
const cavunityBase = "cavunity";
const advancedBase = "reportsInfo";
const entityBase = "entityInfo";

function buildTable(data = []) {
  const tableLabels = {
    entityName: "",
    erPaidLtdOfferedToFulltime: "Offers Employer Paid LTD",
    ratePer100OfMonthlySalary: "Rate per $100 of Monthly Payroll",
    percentageOfMonthlySalary: "Benefit Percentage",
    waitingPeriodDisplay: "Benefit Waiting Period",
  };

  const output = [];
  const keys = Object.keys(tableLabels);

  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    output.push([tableLabels[key]]);
    for (let j = 0; j < data.length; j++) {
      let d = data[j][key];

      if (d === undefined || d === true || d === false) {
        d = d === undefined ? "N/A" : d;
        d = d === true ? "Yes" : d;
        d = d === false ? "No" : d;
      } else if (i === 2) {
        /* this is the Rate per $100 of Monthly Salary */
        d = `$${d}`;
      } else if (i === 3) {
        /* this is the percetage of Monthly Salary */
        d = `${d}%`;
      }

      output[i].push(d);
    }
  }

  return output;
}

export default {
  name: "ReportsOther",
  props: {
    displayPrint: {
      default: true,
      type: Boolean,
    },
    isAdvancedReporting: Boolean,
  },
  mixins: [HashMixin],
  components: {
    LoadingSpinner,
    Error,
    PrintTableBtn,
  },
  created() {
    if (this.sectionState == "NOT_LOADED" || true == this.isAdvancedReporting) {
      this.getData();
    }
  },
  computed: {
    ...mapState(base, ["sectionState", "data", "loadFail", "errors"]),
    ...mapState(cavunityBase, ["reportDriverState"]),
    ...mapState(advancedBase, ["advancedReportState"]),
    ...mapGetters(base, []),
    ...mapGetters(cavunityBase, ["getSelectedEntities"]),
    ...mapGetters(advancedBase, ["getAdvancedReportEntities"]),
    ...mapGetters(entityBase, ["entityID"]),
    hasErrors() {
      return this.errors?.length;
    },
    reportFilename() {
      let reportTitle = this.reportTitle;

      reportTitle = reportTitle.replace(/\s+/g, "");
      return false == this.isAdvancedReporting
        ? `CAVUnityReports-${reportTitle}`
        : `AdvancedReports-${reportTitle}`;
    },
    reportReadyState() {
      return false == this.isAdvancedReporting
        ? this.reportDriverState
        : this.advancedReportState;
    },
    reportTitle() {
      return "Long Term Disability";
    },
  },
  methods: {
    ...mapActions(base, ["getData"]),
    getTableData() {
      let selectedEntityData = null;

      if (false == this.isAdvancedReporting) {
        selectedEntityData = this.getSelectedEntities({
          data: this.data,
          entityID: this.entityID,
        });
      } else {
        selectedEntityData = this.getAdvancedReportEntities({
          data: this.data,
          entityID: this.entityID,
        });
      }
      return buildTable(selectedEntityData);
    },
  },
  watch: {
    reportDriverState(newVal) {
      if (newVal === "CHANGE_MADE") {
        this.$store.commit(
          `${cavunityBase}/UPDATE_REPORT_DRIVER_STATE`,
          "NO_CHANGES"
        );
      }
    },
  },
};
</script>
